import React, { useState, Fragment, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CustomPaging,
  FilteringState,
  IntegratedSelection,
  PagingState,
  SelectionState,
  SortingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
  TableSelection,
} from "@devexpress/dx-react-grid-material-ui";

import MultiPartUpdate from "./MultiPartUpdate";
import {
  ElapsedTimeTypeProvider,
  PartStatusTypeProvider,
  InvoiceTypeProvider,
  HeadTypeProvider,
} from "./TypeProviders";
import { AuthContext } from "../../helpers/auth";

const PartTable = (props) => {
  const { parts, onChange } = props;
  const auth = useContext(AuthContext);
  const userType = auth.meta.user_type;
  const editionPermission = userType !== 4;

  const [selection, setSelection] = useState([]);
  const [editParts, setEditParts] = useState(false);
  const [partsChanged, setPartsChanged] = useState(false);

  const columns = [
    { name: "rfdcno", title: "DOCUMENT" },
    { name: "sos1", title: "SOS" },
    { name: "pano20", title: "PANO" },
    { name: "fcabn6", title: "FCABN6" },
    { name: "bectyc", title: "BECTYC" },
    { name: "qty4", title: "QTY4" },
    { name: "tfrqty", title: "TFRQTY" },
    { name: "spqty", title: "SPQTY" },
    { name: "status", title: "STATUS" },
    { name: "endt8", title: "ENDT8" },
    { name: "estimated_time", title: "ETA" },
    { name: "override_time", title: "MANUAL ETA" },
    { name: "purchase_order", title: "PURCHASE ORDER" },
    { name: "invoice", title: "INVOICE" },
    { name: "additional_charges", title: "AD. CHARGES" },
    { name: "notes", title: "NOTES" },
    { name: "private_notes", title: "PRIV. NOTES" },
  ];

  // filtering
  const { hasFilters, filters, setFilters } = props;
  // paging
  const {
    hasPaging,
    count,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  } = props;
  const pages = Math.ceil(count / pageSize);

  // sorting
  const { hasSorting, sorting, setSorting } = props;

  return (
    <Fragment>
      <div className="card mb-5 py-3 px-3">
        <div className="level">
          <div className="level-left">
            <div className="field is-grouped">
              <div className="field has-addons mb-0 mr-3">
                <p className="control">
                  {editionPermission && (
                    <button
                      className="button is-light"
                      disabled={selection.length === 0}
                      onClick={() => {
                        setEditParts(true);
                      }}
                    >
                      <span className="icon is-small">
                        <FontAwesomeIcon icon={["fas", "pencil-alt"]} />
                      </span>
                      <span>Editar</span>
                    </button>
                  )}
                </p>
              </div>

              {props.actions
                ? props.actions.map((action, it) => (
                    <div key={it}>{action}</div>
                  ))
                : null}

              <div
                className="field has-addons mb-0 mr-3"
                style={{ display: "none" }}
              >
                <p className="control">
                  <button className="button is-light">
                    <span className="icon is-small">
                      <FontAwesomeIcon icon={["far", "file-excel"]} />
                    </span>
                    <span>Descargar</span>
                  </button>
                </p>
              </div>
            </div>
          </div>
          <div className="level-right">
            {hasPaging ? (
              <div className="field is-grouped">
                <div className="field has-addons mb-0 mr-3">
                  <p className="control">
                    <button
                      className="button is-light"
                      disabled={currentPage === 0}
                      onClick={() => {
                        setCurrentPage(currentPage - 1);
                      }}
                    >
                      <FontAwesomeIcon icon={["fas", "chevron-left"]} />
                    </button>
                  </p>
                  <p className="control">
                    <button className="button is-light">
                      {currentPage + 1}
                    </button>
                  </p>
                  <p className="control">
                    <button
                      className="button is-light"
                      disabled={currentPage === pages - 1}
                      onClick={() => {
                        setCurrentPage(currentPage + 1);
                      }}
                    >
                      <FontAwesomeIcon icon={["fas", "chevron-right"]} />
                    </button>
                  </p>
                </div>

                <div className="field" style={{ lineHeight: "40px" }}>
                  <span>de {pages}</span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="card" style={{ overflow: "auto" }}>
        <Grid rows={parts} columns={columns}>
          {/* table state */}
          {hasFilters ? (
            <FilteringState filters={filters} onFiltersChange={setFilters} />
          ) : null}
          {hasPaging ? (
            <PagingState
              currentPage={currentPage}
              onCurrentPageChange={setCurrentPage}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
            />
          ) : null}
          <SelectionState
            selection={selection}
            onSelectionChange={setSelection}
          />
          {hasSorting ? (
            <SortingState sorting={sorting} onSortingChange={setSorting} />
          ) : null}

          {/* table internal state */}
          {hasPaging ? <CustomPaging totalCount={count} /> : null}
          <IntegratedSelection />

          {/* data format */}
          <PartStatusTypeProvider for={["status"]} />
          <InvoiceTypeProvider for={["invoice"]} />
          <HeadTypeProvider for={["rfdcno"]} />
          <ElapsedTimeTypeProvider for={["endt8"]} />

          {/* table rendering */}
          <Table />
          <TableHeaderRow showSortingControls={hasSorting} />
          <TableSelection selectByRowClick highlightRow showSelectAll />
          {hasFilters ? <TableFilterRow /> : null}
          {hasPaging ? <PagingPanel pageSizes={[5, 20, 50, 100]} /> : null}
        </Grid>
      </div>
      <MultiPartUpdate
        active={editParts}

        selection = {
          selection.filter( function ( member ) {
            return member !== undefined

          }).map(function(ix){
            if(parts[ix] != undefined){
              return parts[ix].id
            }
        }).filter(id => id !== undefined)
        }

        onChange={() => {
          setPartsChanged(true);
        }}
        onClose={() => {
          if (partsChanged) {
            onChange();
          }
          setEditParts(false);
        }}
      />
    </Fragment>
  );
};

export default PartTable;
